module.exports = __webpack_public_path__ + "img/winer-sustainability-icon.f03a762d.png";